<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <data-table
                        :headings="documentsHeadings"
                        :data="documents"
                        :hasActions="true"
                        :hasCustomActionComponent="true"
                        :hasNoPaging="true"
                        :hasNoFilter="true"
                        v-if="!loading">
                    <template #actionComponent="{ documentId }">
                        <button class="btn btn-link" @click="downloadDocument(documentId)">
                            Download
                        </button>
                    </template>
                </data-table>
                <loading-spinner :showSpinner="loading"></loading-spinner>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" :disabled="loading" @click="onModalCloseClick" >Close</button>
            </div>
        </div>
    </div>
</div>